// extracted by mini-css-extract-plugin
export default {"accessibleMessage":"LoaderWrapper_accessibleMessage__R95D5"};